class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.container = document.querySelector(`${this.dataset.targetWrapper}`);
    this.url = this.getAttribute('data-next-page-url');
    this.button = this.querySelector('[data-load-more-btn]');
    this.progressInfo = this.querySelector('[data-progress-info]');

    this.init();
  }

  init() {
    if (!this.container || !this.url) return;

    this.button.addEventListener('click',  (event) => {
      event.preventDefault();
      this.getData(this, event);
    });

    this.button.addEventListener('keydown', (event) => {
      event.preventDefault();
      if (event.key === 'Enter') {
        this.getData(this, event);
      }
    });
  }

  getData() {
    this.button.classList.add('is-loading');

    fetch(this.url)
      .then(response => response.text())
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.button.classList.remove('is-loading');

        this.addProducts(parsedHTML);
        this.changeUrl(parsedHTML);
        this.updateProgressBar(parsedHTML);
      });
  }

  addProducts(html) {
    const productCards = html.querySelectorAll('.grid-item');
    const productCardsToRender = Array.from(productCards);
    productCardsToRender.forEach((element) => {
      this.container.append(element);
    });
  }

  changeUrl(html) {
    const btn = html.querySelector('[data-next-page-url]') || null;

    this.url = btn ? btn.getAttribute('data-next-page-url') :  null;

    if (!this.url) {
      this.button.classList.add('hidden');
      return false;
    }

    this.setAttribute('data-next-page-url', this.url);
  }

  updateProgressBar(html) {
    const progressInfoNew = html.querySelector('[data-progress-info]');

    if (progressInfoNew && this.progressInfo) {
      this.progressInfo.innerHTML = progressInfoNew.innerHTML;
    }

  }
}

customElements.define('load-more', LoadMore);
